import RMSConfirmPortfolioContainer from "./RMSConfirmPortfolioContainer";
import RMSConfirmPortfolioStore from "./RMSConfirmPortfolioStore";

export default RMSConfirmPortfolioStore(RMSConfirmPortfolioContainer);
